import styled from "styled-components"

export const Home = styled.div`
    width: 100%;
    margin: 20px auto;
    text-align: center;
    color: #fff;
`
